// Dealer Settings
export const SET_DEALER_SETTINGS = 'SET_DEALER_SETTINGS';
export const SET_AMENITIES = 'SET_AMENITIES';



// WEBPACK FOOTER //
// ./src/store/reducers/dealerSettings/actionTypes.js